import _ from 'lodash';

import Constants from '../Constants';
import RenderingState from '../RenderingState';
import BoundingBox from './BoundingBox';
import VirtualDomLayer from './VirtualDomLayer';

export default class StaticWordElementsLayer extends VirtualDomLayer {
  /*
    specialized class that renders static elements with non intersecting bounding boxes
    */

  constructor(props) {
    super(props);
  }

  override drawElementsInViewPort(
    viewPort: any,
    ctx: any,
    transform: any,
    scaling: any,
    renderingState: RenderingState,
  ): void {
    let i = 0;

    const boundingBoxes: BoundingBox[] = [];

    const wordElementsInViewPort = this.getStaticElementsInViewPort(
      viewPort,
      transform,
    );

    //make sure that elements that were drawn during the last render are drawn first (otherwise they pop up and disappear which causes bad ux)

    const sortedElementsInViewPort = _.sortBy(
      wordElementsInViewPort,
      element => {
        return [
          element.get('rank') || Number.MAX_SAFE_INTEGER,
          element.get('level'),
        ]; //sort by level first, by draw order
      },
    );

    let rank = Date.now();
    const dont_draws = [];
    const draws = [];
    for (const wordElement of sortedElementsInViewPort) {
      rank += 1;
      const newBoundingBox = wordElement.getBoundingBox(transform);

      let foundCollision = false;
      for (const boundingBox of boundingBoxes) {
        if (boundingBox.intersects(newBoundingBox)) {
          foundCollision = true;
          if (Constants.wordElement.placeholderWordElements) {
            wordElement.drawPlaceHolder(ctx, transform, scaling);
          }
          dont_draws.push(wordElement.get('text'));
          if (wordElement.get('opacity') > 0.1) {
            if (renderingState.hasZoomedOut()) {
              wordElement.fadeOut(
                Constants.wordElement.fadeOutDurationWordElement,
              );
              wordElement.draw(ctx, transform, scaling);
            } else {
              wordElement.set('opacity', 0);
            }
          }
          break;
        }
      }
      if (!foundCollision) {
        draws.push(wordElement.get('text'));
        if (renderingState.hasZoomedIn()) {
          wordElement.fadeIn(Constants.wordElement.fadeInDurationWordElement);
        } else {
          wordElement.set('opacity', 1);
        }
        if (!wordElement.get('rank')) {
          wordElement.set('rank', rank);
        }
        wordElement.draw(ctx, transform, scaling);
        boundingBoxes.push(newBoundingBox);
        i++;
      }

      if (i > Constants.wordElement.maxWordElementsInViewPoirt) {
        break;
      }
    }
  }
}
